import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { SelectValueViewer } from 'components';
import MarketAdjustmentLedgerContext from 'pages/Valuations/approaches/backsolveApproach/MarketAdjustmentLedger/util/MarketAdjustmentLedgerContext';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';
import { MarketAdjustmentSelectValueViewerProps } from './MarketAdjustmentSelectValueViewer.props';

const MarketAdjustmentSelectValueViewer = (props: MarketAdjustmentSelectValueViewerProps) => {
  const { cellOptions } = useContext(MarketAdjustmentLedgerContext);
  const optionsData = isEmpty(cellOptions)
    ? (props.cell.sheet?.tableData as any).approach.valuations_approach_backsolve
    : cellOptions;
  const options = getSelectionCellOptions({
    specificApproach: optionsData,
  });
  return <SelectValueViewer options={options} {...props} useLabel />;
};

export default MarketAdjustmentSelectValueViewer;
